<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

@font-face {
  font-family: "Gill Sans Bold";
  font-style: normal;
  font-weight: normal;
  src: local("Gill Sans Bold"),
    url("./assets/fonts/GillSansBold.woff") format("woff");
}
</style>

<style scoped>
.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}

.layout-logo {
  /* width: 100px; */
  /* height: 30px; */
  /* background: #5b6270; */
  /* border-radius: 3px; */
  float: left;
  position: relative;
  /* top: 9px; */
  /* left: 44px; */
  width: 220px;
  text-align: center;

  /* color: #4caf50;  */
  /* color: #2D8CF0; */
  /* color: white; */
  font-family: "Gill Sans Bold";
  font-weight: normal;
  font-size: 26px;
}

.layout-nav {
  /* width: 420px; */
  /* margin: 0 auto; */
  /* margin-right: 20px; */
  /* float: right; */
  /* color: white; */
}
</style>

<template>
  <!-- <div class="layout"> -->
  <Layout>
    <Header
      :style="{ 'z-index': 1000, position: 'fixed', left: 0, top: 0, right: 0, heightx: '40px', margin: 0, padding: 0 }">
      <Menu mode="horizontal" theme="light" :active-name="$route.path" :stylex="{ heightx: '40px' }">
        <div class="layout-logo">
          <i>BTN</i>.CMS
          <!-- DEV TOOLS -->
        </div>
        <div class="layout-nav" v-if="$store.state.isAuthenticated">
          <MenuItem name="/" to="/">
          <Icon type="ios-play" size="24"></Icon>Menu
          </MenuItem>

          <!-- <MenuItem name="/dashboard" to="/dashboard" target="_blank">
                                <Icon type="ios-speedometer" size="24" />Statistik
                            </MenuItem> -->

          <!-- <MenuItem name="/stats" to="/stats">
                                <Icon type="ios-speedometer" size="24" />Statistik
                            </MenuItem> -->

          <MenuItem name="/mon" to="/mon">
          <Icon type="ios-pulse" size="24" />Terminal Monitoring
          </MenuItem>

          <MenuItem v-if="$store.state.isAdmin" name="/users" to="/users">
          <Icon type="ios-contacts" size="24"></Icon>User Management
          </MenuItem>

          <!-- <MenuItem name="3" :style="{float: 'right'}">
                            <Icon type="ios-exit" size=20></Icon>
                            Logout
                            </MenuItem>-->
        </div>

        <!-- <div v-if="$store.state.isAuthenticated" :style="{ float: 'right', height: 'inherited', 'margin-right': '13px' }">
        
      </div> -->

        <div v-if="$store.state.isAuthenticated"
          :style="{ float: 'right', height: 'inherited', 'margin-right': '13px' }">
          <!-- <Button icon="ios-exit" typex="primary">Logout</Button> -->

          Masa berlaku: 10 Maret 2026 - 10 Maret 2029

          <ButtonGroup sizeX="small" :style="{ 'margin-left': '10px' }">
            <Button icon="ios-megaphone" @click="publish()">Publish</Button>
            <!-- <Button icon="ios-settings-outline" @click="showSettings=true"></Button> -->
            <Button icon="ios-power" @click="logout"></Button>
          </ButtonGroup>

          <!-- <Icon type="ios-settings" /> -->
          <!-- <Button icon="ios-power" @click="logout">Logout</Button> -->

          <!-- <Button>
        					<Icon type="ios-power" size=14></Icon>
        					Logout
                            </Button>-->
        </div>
      </Menu>
    </Header>

    <router-view v-if="$store.state.isAuthenticated" />

    <Modal v-model="loginDlg" width="360" @on-visible-change="getCaptcha" :closable="false" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>Enter Password to Access the System</span>
      </p>
      <div style="text-align:center">
        <p style="margin-bottom: 10px">Log In</p>
        <Input v-model="username" placeholder="User Name" style="margin-bottom: 5px" />
        <Input v-model="password" type="password" placeholder="Enter Password" style="margin-bottom: 10px" />
        <!-- <img :src="captcha"> -->
        <div ref="captcha" @click="getCaptcha(true)"></div>
        <Input v-model="captcha" placeholder="Captcha" style="width: 50%; margin-top: 10px;" />
      </div>
      <div slot="footer">
        <Button type="error" size="large" long @click="authenticate">Authenticate</Button>
      </div>
    </Modal>

    <Settings v-bind:show="showSettings" v-on:close="showSettings = false" />

    <!-- <Footer :style="{position: 'fixed', left: 0, bottom: 0, right: 0, height: '40px', backgroundColor: 'black'}" >Footer</Footer> -->
  </Layout>

  <!-- </div> -->
  <!-- <div id="app">
            <div id="nav">
              <router-link to="/">Home</router-link> |
              <router-link to="/about">About</router-link>
            </div>
            <router-view/>
            </div>-->
</template>

<script>

import Settings from './components/Settings';

export default {
  components: {
    Settings
  },
  data() {
    return {
      loginDlg: false,
      username: "",
      password: "",
      captcha: "",
      captchaText: "",

      showSettings: false,
      config: {
        idleTimeout: 30
      }
    };
  },
  methods: {
    loadPlaylist() {
      return fetch("/api/file.folder")
        .then(resp => (resp.ok ? resp.json() : null))
        .then(data => {
          if (!data || !data.success) {
            return;
          }

          data.payload.sort();

          const tree = [];

          data.payload.forEach(path => {
            const list = path.split("/");

            let treeNode = tree;
            let level = 0;

            list.forEach(name => {
              if (level > 0) {
                let child = treeNode.find(
                  node => node.id === name
                );

                if (!child) {
                  child = {
                    id: name,
                    title: name.toTitleCase(),
                    expand: level < 2 && name !== "assets",
                    children: [],
                    path: path,
                  };
                  treeNode.push(child);
                }

                treeNode = child.children;
              }

              level++;
            });
          });

          this.$store.state.playlist = tree;
        });
    },

    publish() {
      fetch("/api/file.publish")
        .then(resp => resp.json()) // Transform the data into json
        .then(data => {
          if (data.success) {
            // this.$Notice.success({
            // 	title: 'Notification title',
            // 	desc: ''
            // });

            this.$Message.success({
              content: 'Content successfully Published.',
              duration: 3,
            });
          }
        })
        .catch(err => { });
    },
    getCaptcha(visible) {
      if (!visible) {
        return;
      }

      this.username = "";
      this.password = "";
      this.captcha = "";

      fetch("/api/auth.captcha")
        .then(resp => resp.json()) // Transform the data into json
        .then(data => {
          if (data.success) {
            // this.$store.state.accessCode = data.payload.AccessCode || '',
            // this.captcha = data.payload.data;
            this.captchaText = data.payload.text;

            this.$refs.captcha.innerHTML = data.payload.data;
          }
        })
        .catch(err => { });
    },
    authenticate() {
      // console.log(this.accessCode, this.$store.state.accessCode);
      // if (this.accessCode == this.$store.state.accessCode) {
      //     this.loginDlg = false;
      //     this.$store.state.isAuthenticated = true;
      // } else {
      // 	alert('Wrong Password!')
      // }

      // console.log(this.captchaText, this.captcha);

      var afc = parseInt(localStorage.getItem("afc") || "0");

      if (afc >= 5) {
        const ana = new Date(
          localStorage.getItem("ana") || new Date().toISOString()
        );
        const now = new Date();
        if (now < ana) {
          this.getCaptcha(true);
          return this.$Modal.error({
            title: "Login",
            content:
              "5 times invalid login attempts, please try again in 20 minutes"
          });
        } else {
          afc = 0;
          localStorage.removeItem("afc");
          localStorage.removeItem("ana");
        }
      }

      if (this.captchaText != this.captcha) {
        return this.$Modal.error({
          title: "Login",
          content: "Invalid CAPTCHA token"
        });
      }

      if (!this.username || !this.password) {
        return this.$Modal.error({
          title: "Login",
          content: "Please enter username and password."
        });
      }

      if (this.$auth.isAuthenticated()) {
        this.$auth.logout();
      }
      const user = {
        username: this.username,
        password: this.password.hashMD5()
      };
      this.$auth
        .login(user)
        .then(response => {
          // this_.isAuthenticated = this_.$auth.isAuthenticated();
          // this_.response = response
          // console.log(response);

          // console.log(response.data);

          localStorage.removeItem("afc");
          localStorage.removeItem("ana");

          this.loginDlg = false;
          this.$store.state.isAuthenticated = this.$auth.isAuthenticated();
          this.$store.state.isAdmin =
            this.$store.state.isAuthenticated &&
            this.$auth.getPayload().admin;
          this.loadPlaylist();
          if (this.$route.path !== "/") {
            this.$router.push("/");
          }
        })
        .catch(err => {
          // console.log(err);

          function addMinutes(date, minutes) {
            return new Date(date.getTime() + minutes * 60000);
          }

          localStorage.setItem("afc", ++afc);
          if (afc >= 5) {
            localStorage.setItem(
              "ana",
              addMinutes(new Date(), 20).toISOString()
            );
          }

          this.getCaptcha(true);

          this.$Modal.error({
            title: `${err.response.status} (${err.response.statusText})`,
            content: err.response.data.payload
          });
        });
    },

    logout() {
      if (this.$auth.isAuthenticated()) {
        this.$auth.logout();
        this.$store.state.isAuthenticated = this.$auth.isAuthenticated();
        this.$store.state.isAdmin =
          this.$store.state.isAuthenticated &&
          this.$auth.getPayload().admin;
        this.loginDlg = !this.$store.state.isAuthenticated;
      }
    },

  },

  created() {
    // fetch(`http://${window.location.hostname}:3000/api/config.get`)

    this.$store.state.isAuthenticated = this.$auth.isAuthenticated();
    this.$store.state.isAdmin =
      this.$store.state.isAuthenticated && this.$auth.getPayload().admin;

    // console.log(this.$auth.getPayload())
    // console.log(this.$store.state);

    // setTimeout(() => {
    // 	// console.log('auth', this.$store.state.isAuthenticated);
    // 	if (this.$store.state.isAuthenticated) {
    // 		this.$auth.logout();
    // 	}
    // }, 500)

    // fetch('/api/config.get')
    //   .then((resp) => resp.json()) // Transform the data into json
    //   .then((data) => {
    //     if (data.success) {
    //         // this.$store.state.accessCode = data.payload.AccessCode || '',
    //         this.$store.state.playlist = data.payload.Playlist;
    //     }
    // 	});

    if (this.$store.state.isAuthenticated) {
      this.loadPlaylist();
    }

    setTimeout(() => {
      // console.log('auth', this.$store.state.isAuthenticated);
      this.loginDlg = !this.$store.state.isAuthenticated;
    }, 1000);
  }
};
</script>